import { call } from 'redux-saga/effects';
import * as Api from '../../../services/fbm-api';
import { sagaRoutineRequest } from '../../../helpers/saga';
import { fetchUserPermissions as fetchUserPermissionsRoutine } from './routines';

export const fetchUserPermissions = () =>
  sagaRoutineRequest(fetchUserPermissionsRoutine, {
    request: () => call(Api.fetchUserPermissions)
  });
